<template>
  <form-item v-bind="$attrs" v-on="$listeners" :suffix="suffix">
    <el-input v-if="number" oninput="value=value.replace(/[^0-9.]/g,'')" v-model.number="model[$attrs.prop]"
              @change="$emit('change')">
      <label v-if="suffix !== undefined" slot="suffix">{{suffix}}</label>
    </el-input>
    <el-input v-else v-model="model[$attrs.prop]" @change="$emit('change')">
      <label v-if="suffix !== undefined" slot="suffix">{{suffix}}</label>
    </el-input>
  </form-item>
</template>

<script>
  import FormItem from '@/components/form/FormItem'

  export default {
    name: 'InputFormItem',
    components: { FormItem },
    props: {
      number: Boolean,
      suffix: String
    },
    computed: {
      model () {
        let parent = this.$parent
        while (parent) {
          if (parent.model != null) return parent.model
          parent = parent.$parent
        }
        return null
      }
    }
  }
</script>
